import { Box, Button, Icon, Modal } from '@honda-canada/design-system-react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsSelectedFilterEmpty, setSelectedFilterItemsAction } from '../../../core/reducers/vehicleListFilters';
import { selectCardGridType } from '../../../core/reducers/ui';
import FiltersListMobileHeader from './FiltersListMobileHeader';
import themeStyles from '../VehicleListFilters.styles';
import { CardGridType } from '../../../core/types';
const MobileFiltersContainer = themeStyles.apply(Box, 'MobileFiltersContainer');
const FiltersWrapper = themeStyles.apply(Box, 'FiltersWrapper');
const FiltersModal = themeStyles.apply(Box, 'FiltersModal');
const ButtonsContainer = themeStyles.apply(Box, 'ButtonsContainer');
const ShadowBox = themeStyles.apply(Box, 'ShadowBox');
const ResetFiltersButton = themeStyles.apply(Button, 'ResetFiltersButton');
const ResetIcon = themeStyles.apply(Icon, 'ResetIcon');
const PrimaryButton = themeStyles.apply(Button, 'PrimaryButton');
const FiltersListMobile = ({ filterOptionsList }) => {
    const [isMobileFiltersOpen, setMobileFiltersOpen] = useState(false);
    const dispatch = useDispatch();
    const isSelectedFilterEmpty = useSelector(selectIsSelectedFilterEmpty);
    const currentListType = useSelector(selectCardGridType);
    const handlerResetAll = () => {
        dispatch(setSelectedFilterItemsAction([]));
    };
    useEffect(() => {
        if (currentListType === CardGridType.TrimCardGrid) {
            setMobileFiltersOpen(false);
        }
    }, [currentListType]);
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(MobileFiltersContainer, null,
            React.createElement(FiltersWrapper, { "data-testid": "cy-vehicle-list-filters" },
                React.createElement(FiltersListMobileHeader, { setMobileFiltersOpen: setMobileFiltersOpen, isMobileFiltersOpen: false }))),
        React.createElement(Modal, { isOpen: isMobileFiltersOpen, closeModal: () => setMobileFiltersOpen(false), styling: "fullOverlay", allowClose: false }, () => (React.createElement(React.Fragment, null,
            React.createElement(FiltersModal, { "data-testid": "cy-vehicle-list-filters" },
                React.createElement(FiltersListMobileHeader, { setMobileFiltersOpen: setMobileFiltersOpen, isMobileFiltersOpen: true }),
                filterOptionsList),
            React.createElement(ButtonsContainer, { "data-testid": "cy-sticky-buttons-container" },
                React.createElement(ShadowBox, null,
                    React.createElement(ResetFiltersButton, { styling: "secondary", disabled: isSelectedFilterEmpty, onClick: handlerResetAll, "data-testid": "cy-filters-resetFilters-button", tabIndex: 0 },
                        React.createElement(ResetIcon, { name: "reset" }),
                        t('Pages.Models.Exploration.filterResetLabel')),
                    React.createElement(PrimaryButton, { styling: "primary", tabIndex: 0, onClick: () => setMobileFiltersOpen(false), "data-testid": "cy-filters-viewResults-button" }, t('Pages.Models.Exploration.viewResultsButton')))))))));
};
export default FiltersListMobile;
